import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod/v4";
import { modelCoefficientsQueryOptions } from "@/lib/queries/modelCoefficients";
import { historyDetailQueryOptions } from "@/lib/queries/detector/history";
import { userPlanQueryOptions } from "@/lib/queries/payment/userPlan";

const provenanceSearchSchema = z.object({
  history_id: z.uuid().optional().catch(undefined),
});
export const Route = createFileRoute("/_app/_provenance")({
  validateSearch: provenanceSearchSchema,
  loaderDeps: ({ search: { history_id } }) => ({ history_id }),
  async loader({ context: { queryClient }, deps: { history_id } }) {
    queryClient.ensureQueryData(modelCoefficientsQueryOptions);
    queryClient.ensureQueryData(userPlanQueryOptions);
    if (history_id)
      try {
        await queryClient.ensureQueryData(
          historyDetailQueryOptions(history_id),
        );
      } catch {
        throw redirect({
          to: ".",
          search: (s) => {
            delete s.history_id;
            return s;
          },
        });
      }
  },
});
